import { Dispatch } from 'react';

import { PageConfig } from '../../../config/mainPageConfig';
import lediumApi from '../../../utils/lediumApi';
import { PageState } from '../state/initialPageState';

export const SET_LOADING = 'page/SET_LOADING';
export const OVERRIDE_FORM_DATA = 'page/UPDATE_FORM_DATA';
export const UPDATE_FORM_ITEM = 'page/UPDATE_FORM_ITEM';
export const SET_FORM_SUBMITTING = 'page/SET_FORM_SUBMITTING';
export const SET_PAGE_CONFIG = 'page/SET_PAGE_CONFIG';
export const API_REQUEST = 'page/API_REQUEST';
export const API_SUCCESS = 'page/API_SUCCESS';
export const API_FAILURE = 'page/API_FAILURE';

export type PageAction =
    | { type: typeof SET_LOADING; payload: boolean }
    | { type: typeof OVERRIDE_FORM_DATA; payload: Record<string, unknown> }
    | { type: typeof UPDATE_FORM_ITEM; payload: Record<string, unknown> }
    | { type: typeof SET_FORM_SUBMITTING; payload: boolean }
    | { type: typeof SET_PAGE_CONFIG; payload: { pageName: string; pageConfig: PageConfig } }
    | { type: typeof API_REQUEST }
    | { type: typeof API_SUCCESS }
    | { type: typeof API_FAILURE; payload: unknown };

export const usePageActions = (state: PageState, dispatch: Dispatch<PageAction>) => ({
    api: {
        setLoading: (payload: boolean) =>
            dispatch({
                type: SET_LOADING,
                payload
            }),
        loadItem: async <T extends Record<string, unknown>>(
            id: string,
            postUpdate?: (data: T) => T,
            overrideOptions: Record<string, unknown> = {}
        ): Promise<void> => {
            let options = overrideOptions;
            dispatch({ type: API_REQUEST });
            try {
                let data = await lediumApi.get<T>(`${state.pageConfig.fetchEndPoint}/${id}`);
                if (!data) {
                    dispatch({ type: API_FAILURE, payload: new Error('No data returned') });
                    return;
                }
                if (data.locked) {
                    options = { ...options, readOnly: true };
                }
                if (postUpdate) {
                    data = postUpdate(data);
                }
                dispatch({
                    type: OVERRIDE_FORM_DATA,
                    payload: { ...state.pageConfig.initialData, ...data, ...options, loaded: true }
                });
                dispatch({ type: API_SUCCESS });
            } catch (e) {
                dispatch({ type: API_FAILURE, payload: e });
            }
        }
    },
    formData: {
        overrideFormData: (payload: Record<string, unknown>) =>
            dispatch({
                type: OVERRIDE_FORM_DATA,
                payload
            }),

        updateFormItem: (payload: Record<string, unknown>) =>
            dispatch({
                type: UPDATE_FORM_ITEM,
                payload
            }),

        setFormSubmitting: (payload: boolean) =>
            dispatch({
                type: SET_FORM_SUBMITTING,
                payload
            })
    },
    pageConfig: {
        setPageConfig: (payload: { pageName: string; pageConfig: PageConfig }) =>
            dispatch({
                type: SET_PAGE_CONFIG,
                payload
            })
    }
});
